import React from 'react';
import CSelect, { Error } from 'src/components/form/Select';
import { ActionMeta, Props } from 'react-select';
import _ from 'lodash';
import { maturityLevelOptions } from 'src/api/types';
import { MaturityLevel } from 'src/graphql/_generated';

interface MaturitySelectProps extends Omit<Props, 'value' | 'options'> {
  value: MaturityLevel | undefined | null;
  onChange: (
    value: { label: string; value: MaturityLevel },
    meta: ActionMeta<{ label: string; value: MaturityLevel }>,
  ) => void;
  onBlur?: () => void;
  error?: boolean;
  helperText?: string | false;
  disabled?: boolean;
  placeholder?: string;
}

export const MaturitySelect: React.FC<MaturitySelectProps> = ({
  value,
  onChange,
  onBlur,
  error,
  helperText,
  disabled,
  placeholder = 'Select maturity',
  ...rest
}) => {
  return (
    <>
      <CSelect
        isDisabled={disabled}
        value={_.find(maturityLevelOptions, (o) => o.value === value)}
        placeholder={placeholder}
        options={maturityLevelOptions}
        onChange={onChange}
        onBlur={onBlur}
        {...rest}
      />
      {error && helperText && <Error>{helperText}</Error>}
    </>
  );
};
